import React from 'react';
import { svgSprite, Portal } from '../../hybrid/wrappers';
import QRCode from 'react-qr-code';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import css from './qr-styles.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const QrCode = ({ title, closeHandler, val, subtitle, customStyles, size }) => {
    const widthDimensions = useWindowDimensions();

    return (
        <Portal
            customClass={widthDimensions < 768 ? 'modalBottom' : 'modal'}
            fullWidth={widthDimensions < 768}
            closeHandler={closeHandler}
        >
            <div className={css.modalQrWrapper}>
                <div className={css.modalQrHeader}>
                    {widthDimensions < 768 && 0 ? (
                        <div
                            onClick={() => {
                                closeHandler(false);
                            }}
                            className={css.qrCodDecor}
                        />
                    ) : (
                        <div onClick={() => closeHandler(false)} className={classNames('circleButton', css.modalQrClose)}>
                            {svgSprite('cross', {
                                className: css.modalQrCloseSvg
                            })}
                        </div>
                    )}
                    <p className={css.modalQrTitle}>{title}</p>
                </div>
                <div className={css.modalQrBody}>
                    {subtitle && <p className={css.modalQrSub}>{subtitle}</p>}
                    <div style={customStyles?.qrCod || {}} className={css.qrCod}>
                        <QRCode size={size || 256} bgColor={'var(--greyExtraDarkColorTransparent)'} value={val} />
                    </div>
                </div>
            </div>
        </Portal>
    );
};

QrCode.propTypes = {
    css: PropTypes.object,
    title: PropTypes.node,
    closeHandler: PropTypes.func,
    val: PropTypes.string,
    subtitle: PropTypes.node,
    customStyles: PropTypes.object,
    size: PropTypes.number
};
export default QrCode;
